import type { State } from 'redux-store/Store';

export const selectJwtToken = (state: State) => state.authData.token;
export const selectJwtRefreshToken = (state: State) =>
	state.authData.refresh_token;
export const selectUserRoles = (state: State) => state.authData.roles;
export const selectExpTime = (state: State) => state.authData.exp;
